import React from 'react';
import useLanguage from '@/hooks/useLanguage';

interface translatePropsType {
  content: string;
  items?: { [key: string]: string | number };
}
const Translate: React.FC<translatePropsType> = ({ content, items }) => {
  const { t } = useLanguage();
  return <>{t(content, items)}</>;
};

export default Translate;
